/**
 * Which two colours a `MuscleFigure` paints primary and secondary in.
 *
 * A module of its own for two reasons. A legend has to read what the figure
 * PAINTS rather than restate it -- `MusclesArtifactCard`'s own comment says a
 * legend that does not match the figure is worse than no legend at all -- and
 * a component file that also exports a function breaks fast refresh.
 *
 * `'amber'` is what the figure has always done and stays the default, so the
 * seven existing call sites are byte-unchanged in behaviour.
 *
 * `'two-tone'` is SB-4's (cycle 003, D-11). The spec requires three EXPLICITLY
 * LEGENDED states and says "two-tone beats a single heat colour" -- which the
 * default is not: `amber` and `amberEmphasis` are the same hue at two
 * opacities, and at 84 px on a warm dark canvas that is a brightness
 * difference, which is the first thing a small silhouette loses. Every
 * shipping three-state legend in the research is genuinely multi-hue (Garmin
 * red / yellow / grey, Peloton yellow / green), and the negative case is the
 * strongest: Equinox+'s photoreal glow bleeds across muscle boundaries and you
 * cannot tell where glutes end and hamstrings begin.
 *
 * Opt-in rather than global: changing the secondary fill for everyone would
 * silently restyle the dashboard body map, two journey panels and the coach's
 * muscles card, none of which is in SB-4's scope. Palette stays Groundwork's
 * three existing tokens, so this introduces no new colour literal.
 */

import { TOKENS } from '../ui/dashboard-primitives'

export type MusclePalette = 'amber' | 'two-tone'

export interface MuscleFills {
  primary: string
  secondary: string
  untargeted: string
}

export function muscleFills(palette: MusclePalette = 'amber'): MuscleFills {
  return palette === 'two-tone'
    ? { primary: TOKENS.amber, secondary: TOKENS.terracotta, untargeted: TOKENS.creamBorder }
    : { primary: TOKENS.amber, secondary: TOKENS.amberEmphasis, untargeted: TOKENS.creamBorder }
}
